import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingOveragesTooltip from '@/components/Billing/BillingOveragesTooltip.vue';
// @ts-ignore
import BillingPlanCardSlotHandler from '@/components/Billing/BillingPlanCardSlotHandler.vue';
import BillingService from '@/components/Billing/billing-service';
import { COMPARE_BILLING_PLANS_URL, VIRTUALLY_UNLIMITED_IDENTIFIER } from '@/components/Billing/billing-service.const';
import {
	SelectOption,
	ProductType,
	FeatureTypes,
	ProductInvoicePreview,
	PricePreviewInputParams,
} from '@/components/Billing/billing-types';
// @ts-ignore
import { getReadableAmountInDollars } from '@/utils/helpers';

export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradePlanDialogSelectPlan',
  props: {
    planId: null,
    quantity: null,
    totalDueToday: null,
    productId: null,
    disableToggle: { type: Boolean },
    featureId: null,
    isEnterprisePlan: { type: Boolean },
    selectOptions: null
  },
  emits: ["plan-changed", "quantity-changed", "update:totalDueToday"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'plan-changed', newPlanId: string): void;
	(e: 'quantity-changed', newQuantity: number): void;
	(e: 'update:totalDueToday', totalDueToday: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	planId: string;
	quantity?: number;
	totalDueToday: number;
	productId: ProductType;
	disableToggle: boolean;
	featureId: FeatureTypes;
	isEnterprisePlan: boolean;
	selectOptions: SelectOption[];
}

const virtualUnlimitedPlanSuffix = `-${VIRTUALLY_UNLIMITED_IDENTIFIER}`;

const managePlansHref = `${process.env.VUE_APP_APP_URL}customize-plan`;


const { isAnnuallyPlan, billingPeriod, usePlanById, getBillingPreview, useProduct, customerData } = useBilling();
const selectedTab = computed(() => (props.planId.includes(virtualUnlimitedPlanSuffix) ? 1 : 0));

const updateSelectedTab = (tabIndex: number) => {
	emit('plan-changed', tabIndex === 1 ? props.planId + virtualUnlimitedPlanSuffix : props.planId.replace(virtualUnlimitedPlanSuffix, ''));
};
const plan = computed(() => usePlanById().value(props.planId));
const isTeamProduct = computed(() => props.productId === ProductType.TeamFeatures);

const planReadableName = computed(() =>
	BillingService.getPlanReadableName({
		planId: props.planId,
		quantity: props.quantity,
		productType: props.productId,
	})
);
const planDescriptions = computed(() => BillingService.getPlanDescriptions(plan.value));

const readableTotalDueToday = computed(() => getReadableAmountInDollars(props.totalDueToday));
const readableRenewableAmount = computed(() => getReadableAmountInDollars(renewAmount.value));

const isLoadingPrice = ref(false);
const showErrorMessage = ref(false);
const renewAmount = ref(0);
const getPricePreview = async ({ planId, productId, unitQuantity, billingPeriod }: PricePreviewInputParams) => {
	let res: ProductInvoicePreview = {} as ProductInvoicePreview;
	showErrorMessage.value = false;
	try {
		isLoadingPrice.value = true;
		res = await getBillingPreview({
			pricePreviewInput: BillingService.buildPricePreviewInput({ productId, planId, unitQuantity, billingPeriod }),
		});
		const previewPrices = BillingService.getProductPricePreview(res);
		renewAmount.value = previewPrices.upComingInvoice;
		emit('update:totalDueToday', previewPrices.dueToday);
		return res;
	} catch (e) {
		showErrorMessage.value = true;
	} finally {
		isLoadingPrice.value = false;
	}
	return res;
};

const teamPrices = computed(() =>
	isTeamProduct.value
		? BillingService.getUsersPrice(useProduct.value(ProductType.TeamFeatures), plan.value, billingPeriod.value, selectedTab.value === 1)
		: [0, 0]
);
const readableTeamStandardPrice = computed(() => getReadableAmountInDollars(teamPrices.value[0]));
const readableTeamPremiumPrice = computed(() => getReadableAmountInDollars(teamPrices.value[1]));

const amountOfStandardMembers = computed(() => customerData.value.standard_users_count);
const amountOfPremiumMembers = computed(() => customerData.value.premium_users_count);

getPricePreview({
	planId: props.planId,
	productId: props.productId,
	unitQuantity: props.quantity,
	billingPeriod: billingPeriod.value,
});

return { __sfc: true,virtualUnlimitedPlanSuffix, emit, managePlansHref, props, isAnnuallyPlan, billingPeriod, usePlanById, getBillingPreview, useProduct, customerData, selectedTab, updateSelectedTab, plan, isTeamProduct, planReadableName, planDescriptions, readableTotalDueToday, readableRenewableAmount, isLoadingPrice, showErrorMessage, renewAmount, getPricePreview, teamPrices, readableTeamStandardPrice, readableTeamPremiumPrice, amountOfStandardMembers, amountOfPremiumMembers, BillingOveragesTooltip, BillingPlanCardSlotHandler, COMPARE_BILLING_PLANS_URL }
}

})